/**
 * Created by anatolij on 07.10.2026
 */

const RoyalLeagueTierWindow = Prefab.createWindow("royal_league_tier_window", "royal_league_tier_window_prefab_json", {
    bundles: ["royal_league_window", "royal_league_table"]
});
